if (!customElements.get('lg-purchase-options')) {
  class LgPurchaseOptions extends HTMLElement {
    constructor () {
      super();

      this.form = this.closest('form')
      this.template = document.body.dataset.template
      this.querySelectorAll('.js-purchase-option').forEach(el => el.addEventListener('change', this.handlePurchaseOption.bind(this)))
      this.form.querySelectorAll('[name="quantity"]').forEach(el => el.addEventListener('change', this.handleQuantityChange.bind(this)))
      this.oneTimePrices = this.querySelectorAll('.js-onetime-price')
      this.recurringPrices = this.querySelectorAll('.js-autodeliver-price')
      this.currentVariant = JSON.parse(this.form.querySelector('[data-current-variant-json]').textContent)

      this.giftCheckbox = this.querySelector('.js-is-gift')
      this.giftForm = this.querySelector('.js-gift-form')
      this.giftEmailInput = this.querySelector('.js-gift-email')

      this.giftEmail = ''
    }

    connectedCallback () {
      if (!!this.giftCheckbox) {
        this.giftCheckbox.addEventListener('input', this.handleGiftCheckbox.bind(this))
      }

      if (!!this.giftEmailInput) {
        this.giftEmailInput.addEventListener('input', this.handleEmailInput.bind(this))
      }

      const checkedOption = this.querySelector('.js-purchase-option:checked')
      if (checkedOption) {
        this.handlePurchaseOption({ target: checkedOption })
      }
    }

    validateEmail (email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }

    handlePurchaseOption (event) {
      const purchaseType = event.target.value
      const sellingPlanSelect = this.querySelector('.js-product-selling-plan')

      if (purchaseType === 'onetime') {
        sellingPlanSelect?.removeAttribute('name')
        if (this.template !== 'product') this.recurringPrices.forEach(el => {
          el.classList.add('hide')
        })

        if (this.giftCheckbox?.checked) {
          this.giftCheckbox.checked = false
          this.giftForm?.classList.remove('active')
          this.querySelectorAll('.js-gift-input').forEach(input => input.setAttribute('disabled', true))
          this.form.querySelector('[data-add-to-cart]')?.removeAttribute('disabled')
        }

      } else {
        sellingPlanSelect?.setAttribute('name', 'selling_plan')

        if (this.template !== 'product') this.recurringPrices.forEach(el => {
          el.classList.remove('hide')
        })
      }

      document.querySelector('[data-add-to-cart]').setAttribute('data-purchase-type', purchaseType)

      this.querySelectorAll('.rc_block__type').forEach(el => {
        if (el.classList.contains(`rc_block__type__${purchaseType}`)) {
          el.classList.add('rc_block__type--active')
        } else {
          el.classList.remove('rc_block__type--active')
        }
      })
    }

    handleQuantityChange (event) {
      // When quantity radio buttons change, they change variants
      // Get the updated variant from the form (the variant system updates this)
      const variantJsonEl = this.form.querySelector('[data-current-variant-json]')
      if (!variantJsonEl) return
      
      const variant = JSON.parse(variantJsonEl.textContent)
      const quantity = parseInt(event.target.value)

      // Update one-time price - use variant price directly (variant already represents the selected pack size)
      this.oneTimePrices.forEach(el => {
        el.innerHTML = theme.Currency.formatMoney(variant.price)
      })

      // Update subscription price if there's a selected selling plan
      let sellingPlanId = this.querySelector('[name="selling_plan"]')?.value
      if (!sellingPlanId && variant.selling_plan_allocations?.length > 0) {
        sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;
      }
      
      if (!sellingPlanId || !variant.selling_plan_allocations) return;

      const sellingPlan = variant.selling_plan_allocations.find(e => e.selling_plan_id === +sellingPlanId)
      if (!sellingPlan) return;

      // Update subscription price - use selling plan price directly
      this.recurringPrices.forEach(el => {
        el.innerHTML = theme.Currency.formatMoney(sellingPlan.price)
      })
    }

    handleGiftCheckbox (event) {
      if (event.target.checked) {
        this.giftForm.classList.add('active')
        this.querySelectorAll('.js-gift-input').forEach(input => input.removeAttribute('disabled'))
        this.validateEmailInput()
      } else {
        this.giftForm.classList.remove('active')
        this.querySelectorAll('.js-gift-input').forEach(input => input.setAttribute('disabled', true))
        this.form.querySelector('[data-add-to-cart]').removeAttribute('disabled')
      }
    }

    handleEmailInput (event) {
      this.giftEmail = event.target.value

      this.validateEmailInput()
    }

    validateEmailInput () {
      const isValid = this.validateEmail(this.giftEmail)

      if (isValid) {
        this.form.querySelector('[data-add-to-cart]').removeAttribute('disabled')
      } else {
        this.form.querySelector('[data-add-to-cart]').setAttribute('disabled', true)
      }
    }
  }

  customElements.define('lg-purchase-options', LgPurchaseOptions)
}